module.exports = __webpack_public_path__ + "static/media/newsletter-july-2019-archbishop-john-shahovskoy.d7e74e33.png";